import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import { matchPath } from 'react-router-dom';

const Layout = ({ children }) => {
  const NoFooterRoutes = [
    '/scenarios/manage',
    '/scenarios',
    '/form/collaborators',
    '/form/general',
    '/form/calendar',
    '/form/schedule',
    '/form/legislation',
    '/form/absences',
    '/form/availability',
    '/form/transitions',
    '/form/staff',
    '/form/distribution',
    '/form/sseq',
    '/form/wsum',
    '/form/generate',
    '/result',
    "/login",
    '/forgot-password',
    '/reset-password',
    "/signup",
    '/schedules',
    "/schedules/:id",
    "/schedules/:id/analysis",
    "/profile",
    "/myscenarios",
    '/subscription',
    "/drafts",
    "/teams"
  ];

  const { pathname } = useLocation();
  
  const shouldHideFooter = NoFooterRoutes.some(route => {
    if (route.includes(':')) {
      return matchPath({ path: route }, pathname);
    }
    return pathname === route;
  });

  return (
    <>
      <Header />
      <div>
        {children}
      </div>
      {!shouldHideFooter && <Footer />}
    </>
  );
};

export default Layout;